import React from 'react'

export function DebugOverlay({ onDisable })
{
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 99999,
                border: '1px solid red', // distinctive debug border
                boxSizing: 'border-box',
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    pointerEvents: 'auto',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    padding: '12px',
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    color: 'white',
                    fontFamily: 'monospace',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                }}
            >
                <div style={{ fontWeight: 'bold', color: '#ff4444' }}>DEBUG MODE</div>
                <button
                    onClick={onDisable}
                    style={{
                        backgroundColor: '#333',
                        color: 'white',
                        border: '1px solid #555',
                        padding: '6px 12px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px',
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = '#444')}
                    onMouseOut={(e) => (e.target.style.backgroundColor = '#333')}
                >
                    Disable debug mode
                </button>
            </div>
        </div>
    )
}
